<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <div style="display: inline-block; vertical-align: top; color: #97a8be">
          &nbsp; Welcome, {{ userName }} &nbsp;
        </div>
        <el-tooltip :content="$t('PUB.userRole')" effect="dark" placement="bottom">
          <user-roles class="right-menu-item hover-effect" />
        </el-tooltip>
        <el-tooltip :content="$t('PUB.lang')" effect="dark" placement="bottom">
          <language />
        </el-tooltip>
        <el-tooltip :content="$t('PUB.layoutSize')" effect="dark" placement="bottom">
          <size-select class="right-menu-item hover-effect" />
        </el-tooltip>
      </template>
      <template v-else>
        <el-tooltip :content="$t('PUB.lang')" effect="dark" placement="bottom" >
          <language :icon-size="'16px'"/>
        </el-tooltip>
      </template>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        id="settingUser"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img :src="avatar" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/user/userInfo.htm">
            <el-dropdown-item>{{ $t("PUB.person") }}</el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="setting = true">
            <span>{{ $t("PUB.layout") }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span>{{ $t("PUB.logout") }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import SizeSelect from "@/components/SizeSelect";
import Language from "@/components/Language";
import UserRoles from "@/components/UserRoles";
import defaultUser from "@/assets/defaultUser.png";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    SizeSelect,
    Language,
    UserRoles,
  },
  data() {
    return {
      avatar: this.$store.getters.userInfo.avatar || defaultUser,
      userName: this.$store.getters.userInfo.name || "",
    };
  },
  computed: {
    ...mapGetters(["sidebar", "device"]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings;
      },
      set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "showSettings",
          value: val,
        });
      },
    },
    defaultAvatar() {
      return this.$store.getters.userInfo.avatar;
    },
  },
  watch: {
    defaultAvatar: {
      handler: function (val, oldVal) {
        this.avatar = val || defaultUser;
      },
      immediate: true,
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      this.$confirm(this.$t("PUB.logoutTips"), this.$t("PUB.tips"), {
        confirmButtonText: this.$t("PUB.ok"),
        cancelButtonText: this.$t("PUB.cancel"),
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            location.reload();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 45px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding-right: 5px;
  .hamburger-container {
    line-height: 45px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 45px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -15px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue